// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-rating{display:inline-flex}.v-rating,.v-rating__stars{align-items:center;flex-flow:row nowrap}.v-rating__stars{display:flex}.v-rating__count,.v-rating__stars .v-icon:not(:first-child){margin-left:.1875rem}.v-rating__count{color:#7f839c;font-size:.875rem;line-height:1.0625}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
